import React, { useState, useEffect } from 'react';
import { FaMobileAlt, FaCheckCircle, FaSpinner } from "react-icons/fa";

const PhoneVerificationModal = ({ isOpen, onClose, onVerified, public_request }) => {
    const [otpSent, setOtpSent] = useState(false);
    const [phone, setPhone] = useState("");
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // دالة تحويل الأرقام العربية إلى إنجليزية
    const toEnglishDigits = (str) => {
        return str.replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
            .replace(/[۰-۹]/g, d => "۰۱۲۳٤٥٦۷۸۹".indexOf(d));
    };

    useEffect(() => {
        if (isOpen) {
            const savedPhone = sessionStorage.getItem("pending_otp_phone");
            if (savedPhone) setPhone(savedPhone);
        }
    }, [isOpen]);

    // معالجة إدخال رقم الهاتف
    const handlePhoneChange = (e) => {
        let val = toEnglishDigits(e.target.value);
        if (!val.startsWith("09")) val = "09";
        // const suffix = val.slice(2).replace(/\D/g, "");
        // const finalPhone = ("" + suffix).slice(0, 10);
        setPhone(val);
        if (error) setError("");
    };

    // معالجة إدخال رمز التأكيد (6 أرقام فقط)
    const handleCodeChange = (e) => {
        const val = toEnglishDigits(e.target.value);
        // استخراج الأرقام فقط وتحديد الطول بـ 6 خانات
        const numericValue = val.replace(/\D/g, "").slice(0, 6);
        setCode(numericValue);
        if (error) setError("");
    };

    const handleSendOtp = async () => {
        if (phone.length !== 10 || !phone.startsWith("09")) {
            setError("يرجى ادخال رقم صحيح");
            return;
        }
        setLoading(true);
        setError("");
        try {
            await public_request.post('/public/complaints/phone/send-otp', { phoneNumber: phone });
            setOtpSent(true);
            sessionStorage.setItem("pending_otp_phone", phone);
        } catch (err) {
            setError(err.response?.data?.message || "فشل إرسال الرمز. تأكد من الرقم.");
        } finally { setLoading(false); }
    };

    const handleVerifyOtp = async () => {
        if (code.length < 6) {
            setError("يرجى إدخال رمز التحقق المكون من 6 أرقام");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const response = await public_request.post('/public/complaints/phone/verify-otp', {
                phoneNumber: phone,
                code: code
            });
            const tokenFromServer = response.data.phoneToken || response.data.token || code;
            sessionStorage.removeItem("pending_otp_phone");
            onVerified(phone, tokenFromServer);
        } catch (err) {
            setError(err.response?.data?.message || "رمز التحقق غير صحيح أو منتهي.");
        } finally { setLoading(false); }
    };

    const resetProcess = () => {
        setOtpSent(false);
        setPhone("");
        setCode("");
        setError("");
    };

    if (!isOpen) return null;

    return (
        <div className="otp-modal-overlay" onClick={onClose}>
            <div className="otp-modal-card shadow-lg animate-fade-in" onClick={e => e.stopPropagation()}>
                <div className="otp-icon-header">
                    {!otpSent ? <FaMobileAlt /> : <FaCheckCircle className="text-success" />}
                </div>

                <h3 className="mb-2 text-white fw-bold">التحقق من الهاتف</h3>
                <p className="text-white-50 small mb-4">
                    {otpSent ? "أدخل الرمز المرسل إلى هاتفك" : "أدخل رقم هاتفك لتتمكن من تقديم شكوى رسمية"}
                </p>

                <div className="mb-3">
                    <label className="form-label d-block text-end small text-white-50">رقم الهاتف</label>
                    <input
                        type="tel"
                        placeholder="09xxxxxxxx"
                        className={`form-control otp-input mb-3 ${otpSent ? 'opacity-50' : ''}`}
                        value={phone}
                        onChange={handlePhoneChange}
                        disabled={otpSent}
                        maxLength={10}
                    />

                    {!otpSent ? (
                        <div className="d-grid gap-2">
                            <button
                                className="btn btn-primary py-2 fw-bold rounded-pill"
                                onClick={handleSendOtp}
                                disabled={loading || phone.length !== 10}
                            >
                                {loading ? <FaSpinner className="spinner-icon" /> : "إرسال رمز التحقق"}
                            </button>
                            <button
                                className="btn btn-link text-info small text-decoration-none shadow-none"
                                onClick={() => setOtpSent(true)}
                            >
                                لدي رمز بالفعل؟ أدخله هنا
                            </button>
                        </div>
                    ) : (
                        <div className="animate-fade-in">
                            <label className="form-label d-block text-end small text-white-50">رمز التأكيد (6 أرقام)</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                placeholder="------"
                                className="form-control otp-input code mb-3 fw-bold"
                                style={{ letterSpacing: '8px' }}
                                value={code}
                                onChange={handleCodeChange}
                                maxLength={6}
                                autoFocus
                            />
                            <button
                                className="btn btn-success w-100 py-2 fw-bold rounded-pill"
                                onClick={handleVerifyOtp}
                                disabled={loading || code.length !== 6}
                            >
                                {loading ? <FaSpinner className="spinner-icon" /> : "تأكيد والبدء بالشكوى"}
                            </button>
                            <button className="btn btn-link text-info small w-100 mt-2 text-decoration-none" onClick={resetProcess}>تعديل الرقم؟</button>
                        </div>
                    )}
                </div>

                {error && <div className="otp-error-msg mb-3 text-center">{error}</div>}
                <button className="btn btn-link text-white-50 w-100 text-decoration-none" onClick={onClose}>إلغاء</button>
            </div>

            <style>{`
                .otp-modal-overlay { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.9); display: flex; align-items: center; justify-content: center; z-index: 9999; backdrop-filter: blur(8px); }
                .otp-modal-card { background: #1e293b; padding: 40px; border-radius: 30px; width: 95%; max-width: 400px; text-align: center; border: 1px solid rgba(56, 189, 248, 0.2); }
                .otp-icon-header { width: 70px; height: 70px; background: rgba(56, 189, 248, 0.1); color: #38bdf8; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 2rem; margin: 0 auto 20px; }
                .otp-input { background: #0f172a !important; border: 2px solid #334155 !important; color: white !important; height: 55px; font-size: 1.3rem; text-align: center; border-radius: 15px; }
                .otp-input::placeholder { color: rgba(255, 255, 255, 0.75) !important; font-size: 1.5rem; }
                .otp-error-msg { color: #f87171; font-size: 0.85rem; background: rgba(248, 113, 113, 0.1); padding: 10px; border-radius: 10px; border: 1px solid rgba(248, 113, 113, 0.2); }
                .spinner-icon { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                .animate-fade-in { animation: fadeIn 0.4s ease; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
};

export default PhoneVerificationModal;